import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20platform%20hero%20background%20with%20warm%20coral%20orange%20and%20teal%20color%20gradient%2C%20abstract%20geometric%20shapes%2C%20soft%20flowing%20lines%2C%20clean%20and%20airy%20atmosphere%2C%20light%20and%20bright%20tone%2C%20no%20text%2C%20suitable%20for%20text%20overlay&width=1800&height=1200&seq=hero-cheng91-bg&orientation=landscape"
          alt="成91平台背景"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark overlay for text contrast */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/20 backdrop-blur-sm rounded-full text-background-50 text-sm mb-6">
          <i className="ri-sparkling-2-line"></i>
          <span>2026年8月全新版本发布</span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
          成91平台
        </h1>
        <p className="text-base md:text-lg text-background-100/90 mb-8 max-w-2xl mx-auto leading-relaxed">
          备受关注的热门综合性平台，汇聚丰富资源与专业服务，为您带来全新的数字化体验。立即加入成91，探索无限可能。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#cta"
            className="px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-lg font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg"
          >
            立即探索
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 rounded-lg font-medium text-sm hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/20"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}